import React from "react";
import { captureBagData } from "./CaptureBagData";
import "../../css/components/standardPage.css";

const CaptureBagPage = () => {
  return (
    <div className="standard-page">
      {/* Hero Section */}
      <div
        className={`page-hero ${captureBagData.cardsPosition === 'bottom' ? 'cards-bottom' : ''}`}
        style={{
          backgroundImage: captureBagData.content[0]?.href ? `url(${captureBagData.content[0].href})` : undefined,
        }}
      >
        <div className="hero-overlay"></div>
        
        {/* Main Title */}
        <h1 className="page-title">{captureBagData.title}</h1>
        
        {/* Hero Cards - smaller cards with key points */}
        <div className="hero-cards-container">
          {captureBagData.heroCards.map((card, index) => (
            <div key={index} className="hero-card">
              <h3 className="hero-card-title">{card.title}</h3>
              <p className="hero-card-description">{card.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Content Sections */}
      <div className="content-sections">
        {captureBagData.content.slice(1).map((section, index) => (
          <div
            key={index}
            className={`content-section ${section.cardsPosition === 'bottom' ? 'cards-bottom' : ''}`}
            style={{
              backgroundImage: section.href ? `url(${section.href})` : undefined,
            }}
          >
            <div className="section-overlay"></div>
            {section.title && <h2 className="section-title-overlay">{section.title}</h2>}
            <div className={`section-cards-container ${section.cards.length === 2 ? 'two-cards' : section.cards.length === 3 ? 'three-cards' : ''}`}>
              {section.cards.map((card, cardIndex) => (
                <div key={cardIndex} className="section-card tko-card">
                  {card.icon && (
                    <div className="tko-card-icon">
                      <img src={card.icon} alt={card.title} />
                    </div>
                  )}
                  {card.title && <h3 className="tko-card-title">{card.title}</h3>}
                  <p className="section-card-description">{card.description}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CaptureBagPage;
